import { createFileRoute } from '@tanstack/react-router';
import { parseEnv } from '@/helpers/route-utils';

export const Route = createFileRoute('/_auth/$env/templates/$id')({
  params: parseEnv(),
});
